// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2d84707c","521":"a2a1ef1c"}[chunkId] + ".chunk.js";
};